export default __webpack_public_path__ + "static/media/chart-teaser__dark.c847a7898bcdabe16f87a7fb753529f3.svg";